var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCorner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30.425,
  height: 18.952
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  stroke: "#4e4e4e",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 204",
  d: "M29.93 8.918H.493v3.5l8.023 4.793a21.858 21.858 0 0 0 6.1 1.459 19.332 19.332 0 0 0 5.992-.729l9.326-5.523Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 205",
  d: "M15.237.289.493 8.816l8.023 4.793a21.858 21.858 0 0 0 6.1 1.459 19.332 19.332 0 0 0 5.992-.729l9.326-5.523Z"
}))));
export default SvgCorner;